export default __webpack_public_path__ + "static/media/skye_kinder.f37820c3.jpg";